var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp24G(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "help_24",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "help_24-g",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_15579",
    "data-name": "Rechteck 15579",
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_18717",
    "data-name": "Pfad 18717",
    d: "M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm1,17H11V16h2Zm.974-5.667c-.508.418-.988.814-.975,1.123V14H11v-.5c-.058-1.261.918-2.065,1.7-2.711C13.51,10.124,14,9.671,14,9a2,2,0,0,0-2.381-1.965A2.1,2.1,0,0,0,10,9.147V10H8V9.147a4.073,4.073,0,0,1,3.264-4.08A4,4,0,0,1,16,9a4.339,4.339,0,0,1-2.026,3.333Z",
    fill: "#a3b2bc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_15580",
    "data-name": "Rechteck 15580",
    width: 24,
    height: 24,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp24G);
export default __webpack_public_path__ + "static/media/help_24-g.d7de1d65a0ef0130dc06d79e26290faf.svg";
export { ForwardRef as ReactComponent };